import { Spinner } from '@/shared/components/ui/Spinner';

export function LoadingScreen({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-surface-container-low">
      <Spinner className="h-7 w-7" />
      <p className="text-data-md text-on-surface-variant">{label}</p>
    </div>
  );
}
